import { Helmet } from "react-helmet";
import Footer from "../../components/shared/Footer";
import Navbar from "../../components/shared/Navbar";
import RightBar from "../../components/shared/RightBar";
import BreadCrumbRiplay from "../../components/riplay/BreadCrumbRiplay";
import Content from "../../components/riplay/Content";

export default function Riplay() {
    return (
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <title>Riplay - BPR Palu Anugerah</title>
                <meta name="description" content="Riplay BPR Palu Anugerah." />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Riplay - BPR Palu Anugerah" />
                <meta property="og:description" content="Riplay BPR Palu Anugerah." />
                <meta property="og:type" content="website" />
            </Helmet>
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <BreadCrumbRiplay></BreadCrumbRiplay>
                <Content></Content>
            </main>
            <Footer />
        </div>
    )
}